export const FidelityType = {
  COMO: 'como',
  ZEROSIX: 'zerosix',
  PONGO: 'pongo',
} as const;

export type FidelityType = (typeof FidelityType)[keyof typeof FidelityType];
